import mixpanel from 'mixpanel-browser';

const newLocationContact = () => {
	window.location.href = 'mailto:support@near.st?subject=New Location';
	mixpanel.track('New location contact click');
};

export default newLocationContact;
